import { useLocation } from "wouter";
import { PreferenceCenter } from "@/components/newsletter";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

export default function EmailPreferencesPage() {
  const [, setLocation] = useLocation();

  // Check for email in URL query params
  const urlParams = new URLSearchParams(window.location.search);
  const emailParam = urlParams.get("email");

  return (
    <div className="min-h-screen bg-muted/30">
      <header className="border-b bg-background">
        <div className="max-w-2xl mx-auto px-4 py-4 flex items-center gap-4">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => setLocation("/")}
            className="text-muted-foreground"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Home
          </Button>
        </div>
      </header>

      <main className="max-w-2xl mx-auto px-4 py-12">
        <div className="text-center mb-8">
          <h1 className="font-serif text-3xl font-medium mb-2">
            Email Preferences
          </h1>
          <p className="text-muted-foreground">
            Manage your Life Itself Studio email subscription settings
          </p>
        </div>

        <PreferenceCenter
          email={emailParam || undefined}
          onComplete={() => {
            // Optionally redirect after successful update
          }}
        />

        <div className="mt-8 text-center">
          <p className="text-sm text-muted-foreground">
            Need help? Contact us at{" "}
            <a
              href="mailto:hello@lifeitself.studio"
              className="text-primary hover:underline"
            >
              hello@lifeitself.studio
            </a>
          </p>
        </div>
      </main>
    </div>
  );
}
